<div class="d-flex flex-column gap-3">
  <div class="d-flex flex-column gap-3">
    <span class="beneficiary-title mb-0" i18n>Organization Information</span>
    <div class="changes-container">
      <div class="changes-card">
        <span class="changes-title" i18n>Previous</span>
        <ng-container *ngIf="!(formattedOrgChanges$ | async | previousNotApplicable); else notApplicable">
          <app-submission-detail
            *ngFor="let change of (formattedOrgChanges$ | async)?.previous"
            [label]="change.label"
            [value]="change.value"
            [hasChanged]="change.hasChanged"
            [submissionState]="SubmissionStateEnum.Previous" />
        </ng-container>
      </div>
      <div class="changes-card">
        <span class="changes-title" i18n>New</span>
        <ng-container *ngIf="hasOrgChanges$ | async">
          <app-submission-detail
            *ngFor="let change of (formattedOrgChanges$ | async)?.new"
            [label]="change.label"
            [value]="change.value"
            [hasChanged]="change.hasChanged"
            [submissionState]="SubmissionStateEnum.New" />
        </ng-container>
        <span *ngIf="!(hasOrgChanges$ | async)" class="not-applicable" i18n>No changes</span>
      </div>
    </div>
  </div>
  <div class="d-flex flex-column gap-3">
    <span class="beneficiary-title mb-0" i18n>Primary Contact Information</span>
    <div class="changes-container">
      <div class="changes-card">
        <ng-container *ngIf="!(formattedContactChanges$ | async | previousNotApplicable); else notApplicable">
          <app-submission-detail
            *ngFor="let change of (formattedContactChanges$ | async)?.previous"
            [label]="change.label"
            [value]="change.value"
            [hasChanged]="change.hasChanged"
            [submissionState]="SubmissionStateEnum.Previous" />
        </ng-container>
      </div>
      <div class="changes-card">
        <ng-container *ngIf="hasContactChanges$ | async">
          <app-submission-detail
            *ngFor="let change of (formattedContactChanges$ | async)?.new"
            [label]="change.label"
            [value]="change.value"
            [hasChanged]="change.hasChanged"
            [submissionState]="SubmissionStateEnum.New" />
        </ng-container>
        <span *ngIf="!(hasContactChanges$ | async)" class="not-applicable" i18n>No changes</span>
      </div>
    </div>
  </div>
</div>
<ng-template #notApplicable>
  <span class="not-applicable" i18n>Not applicable</span>
</ng-template>
